export default __webpack_public_path__ + "static/media/bg_2.d62aa088.jpeg";